import React, { useContext } from "react";
import { format_phone, format_phone_for_link } from "../../gloabal-functions/phone-number-correction";
import { daysAgo } from "../../gloabal-functions/days-ago";
import { SearchContext } from "./SearchContext";
import { FaFilter, FaMap } from "react-icons/fa6";
import ServiceList from "./ServiceList";
import ShareBox from "./ShareBox";

const ResultContainer = ({ data, hoveredProviderId, setHoveredProviderId, setShowFilters, setShowMap, radius }) => {
  const { city, state } = useContext(SearchContext);

  return (
    <div>
      {/* Mobile action buttons for toggling filters and map */}
      <div className="md:hidden mb-4 w-full flex justify-between print:hidden">
        <button className="mr-2 text-white py-1 px-3 rounded bg-blue-500 flex items-center" onClick={() => setShowFilters(true)}>
          <FaFilter className="mr-2" /> Show Filters
        </button>
        <button className=" text-white py-1 px-3 rounded bg-blue-500 flex items-center" onClick={() => setShowMap(true)}>
          Show Map <FaMap className="ml-2" />
        </button>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center p-2 mb-4 ">
        <ServiceList />
        <ShareBox />
      </div>

      <div className="mb-2">
        <span className="font-bold">{data.length} Total</span> Results Found within {radius} miles of {city}, {state}
      </div>
      {data.map(item => {
        const isHovered = item.ID === hoveredProviderId;
        const isPremium = item.premium === "1";
        return (
          <div key={item.ID} className={`relative rounded-lg border-2 flex print:flex-row flex-col md:flex-row w-full mb-4  ${isPremium ? "border-yellow-200" : "border-gray-300"} transform transition-transform duration-200 p-2 ${isHovered ? "bg-primaryBlue/10" : ""} `} onMouseEnter={() => setHoveredProviderId(item.ID)} onMouseLeave={() => setHoveredProviderId(null)}>
            {isPremium && item.logo && (
              <div className="w-full print:hidden md:w-[200px] shrink-0 md:mr-2 mb-2 md:mb-0">
                <a href={item.permalink} target="_blank" rel="noopener noreferrer">
                  <img src={item.logo} alt={item.name} className="w-full rounded-lg md:h-[150px] print:w-[150px]  print:h-[150px] " />
                </a>
              </div>
            )}

            <div className="flex flex-col grow">
              <div className="w-full flex justify-between">
                <div>
                  {item.support_radius === "Federal" && <div className="text-xs font-bold text-secondaryColor">National Listing</div>}
                  {item.support_radius === "State" && <div className="text-xs font-bold text-secondaryColor">Statewide Listing</div>}
                  <h2 className="text-lg font-bold">
                    <a href={item.permalink} className="no-underline hover:underline hover:text-primaryBlue" target="_blank">
                      {item.name}
                    </a>
                  </h2>
                </div>
                <div className="text-sm shrink-0 text-right">Last Updated: {daysAgo(item.last_updated)}</div>
              </div>

              <div className="flex flex-wrap md:flex-nowrap justify-between mt-2">
                <div className="w-full md:w-3/4 mb-2 md:mb-0">
                  <div>{item.street_address}</div>
                  <div>
                    {item.city}, {item.state} {item.zip}
                  </div>
                </div>
                <div className="w-full md:w-1/4 text-left md:text-right">
                  <div className="text-lg">
                    <i className="fa-solid fa-phone text-primaryBlue"></i> <a href={format_phone_for_link(item.phone)}>{format_phone(item.phone)}</a>
                  </div>
                </div>
              </div>

              <div className="mt-2">
                {item.advanced_services.length === 0 ? (
                  <div className="text-sm font-semibold">No Advanced Search Options</div>
                ) : (
                  <>
                    <div className="text-sm font-semibold">Advanced Search:</div>
                    <div className="flex flex-wrap md:flex-nowrap">
                      {item.advanced_services.map(service => (
                        <div key={service.term_id} className="py-1 pr-2 mr-2 text-sm">
                          {service.name}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>

              <div className="w-full flex mt-2 border-t border-gray-100 flex-wrap">
                {item.support_terms.length === 0 ? (
                  <p>No support terms</p>
                ) : (
                  item.support_terms.map(term => (
                    <div key={term.term_id} className="font-bold rounded-xl py-1 px-2 mr-2 mt-2 bg-gray-100">
                      {term.name}
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ResultContainer;
